import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  ButtonGroup,
  Button,
  Stack,
  Box,
  alpha,
  Slider,
  TextField,
} from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import SyncIcon from '@mui/icons-material/Sync';
import { Grid } from '@mui/system';
import { useState } from 'react';

const PMAFlags = ({
  deployment,
  flags,
  onFlagChange,
  handleFlagChangeWithValue,
  showWithCard = true,
}) => {
  const [rampUpLimit, setRampUpLimit] = useState(
    Number(flags.startThreshold) || 30,
  );

  const content = (
    <Box>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Konfigurieren Sie die System-Einstellungen für Ihr PMA-Deployment.
      </Typography>

      <Stack spacing={4}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 4,
          }}
        >
          <Box>
            <Typography variant="subtitle1" gutterBottom>
              Wartungsmodus
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Aktiviert oder deaktiviert den Wartungsmodus für das System
            </Typography>
            <ButtonGroup variant="outlined" aria-label="maintenance mode">
              <Button
                onClick={() => onFlagChange('isMaintenanceActive')}
                variant={flags.isMaintenanceActive ? 'contained' : 'outlined'}
                color={flags.isMaintenanceActive ? 'primary' : 'inherit'}
                startIcon={<BuildIcon />}
              >
                {flags.isMaintenanceActive ? 'Aktiviert' : 'Deaktiviert'}
              </Button>
            </ButtonGroup>
          </Box>
          <Box>
            <Typography variant="subtitle1" gutterBottom>
              Hochfahrgrenze (%)
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Legt die minimale Grenze für das Hochfahren des Systems in Prozent
              fest.
            </Typography>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs>
                <Slider
                  value={
                    typeof rampUpLimit === 'number'
                      ? Number(flags.startThreshold)
                      : 0
                  }
                  onChange={(event, newValue) => {
                    setRampUpLimit(newValue);
                    handleFlagChangeWithValue('startThreshold', newValue);
                  }}
                  aria-labelledby="input-slider"
                  min={0}
                  max={100}
                  step={1}
                  sx={{
                    width: '200px',
                  }}
                />
              </Grid>
              <Grid item>
                <TextField
                  value={rampUpLimit}
                  size="small"
                  onChange={(event) => {
                    const value =
                      event.target.value === ''
                        ? ''
                        : Number(event.target.value);
                    setRampUpLimit(value);
                    handleFlagChangeWithValue('startThreshold', value);
                  }}
                  onBlur={() => {
                    if (rampUpLimit < 0) {
                      setRampUpLimit(0);
                    } else if (rampUpLimit > 100) {
                      setRampUpLimit(100);
                    }
                  }}
                  inputProps={{
                    step: 1,
                    min: 0,
                    max: 100,
                    type: 'number',
                    'aria-labelledby': 'input-slider',
                  }}
                  sx={{ width: '80px' }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box>
          <Typography variant="subtitle1" gutterBottom>
            Synchronisierung
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Erlaubt oder verbietet die Synchronisierung von Daten
          </Typography>
          <ButtonGroup variant="outlined" aria-label="syncing acceptance">
            <Button
              onClick={() => onFlagChange('isSyncingAccepted')}
              variant={flags.isSyncingAccepted ? 'contained' : 'outlined'}
              color={flags.isSyncingAccepted ? 'primary' : 'inherit'}
              startIcon={<SyncIcon />}
            >
              {flags.isSyncingAccepted ? 'Erlaubt' : 'Nicht Erlaubt'}
            </Button>
          </ButtonGroup>
        </Box>
      </Stack>
    </Box>
  );

  if (!showWithCard) {
    return content;
  }

  return (
    <Card elevation={2} sx={{ borderRadius: 2, overflow: 'visible' }}>
      <CardHeader
        avatar={<BuildIcon color="primary" />}
        title={<Typography variant="h6">System-Einstellungen</Typography>}
        subheader={`Für ${deployment?.title}`}
        sx={{
          bgcolor: (theme) => alpha(theme.palette.primary.light, 0.1),
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      />
      {content}
      <CardContent sx={{ pt: 3, pb: 2 }}></CardContent>
    </Card>
  );
};

export default PMAFlags;
